

export const getConfig = () => {

  const configEnvironments = {
    lab: {
      userServiceUrl: 'https://iam.lab.cj.com',
    },
    prod: {
      userServiceUrl: 'https://iam.cj.com',
    },
  };

  const hostname = window.location.hostname;

  if (hostname.includes("local")) {
    return {
      userServiceUrl: 'http://localhost:8080',
    }
  }

  if ( hostname.includes("lab.cj.com") ) {
    return configEnvironments['lab'];
  }

  if ( hostname.includes("cj.com")) {
    return configEnvironments['prod'];
  }

  throw Error("No app configuration found for this host: " + hostname);

}